"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pnlExportTypeMap = exports.pnlExportTypes = exports.checkInTypeMap = exports.checkInTypes = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
exports.checkInTypes = [
    'disabled',
    'get',
    'post',
];
exports.checkInTypeMap = {
    disabled: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:CheckInTypeDisabled', defaultMessage: 'Disabled' })),
    get: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:CheckInTypeGet', defaultMessage: 'GET' })),
    post: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit:CheckInTypPost', defaultMessage: 'POST' })),
};
exports.pnlExportTypes = [
    'standard',
    'eurokoha',
];
exports.pnlExportTypeMap = {
    standard: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit/PnlExportType:Standard', defaultMessage: 'Standard' })),
    eurokoha: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Company/Edit/PnlExportType:Eurokoha', defaultMessage: 'Eurokoha' })),
};
//# sourceMappingURL=items.js.map